export enum FILE_ERROR {
  SPREADSHEET_FILE = 'Please select a spreadsheet file.',
}

export type RECORD_ERROR = FILE_ERROR | string;

export enum COLUMN_NAMES {
  PERIOD = 'Period',
  PERMIT_NUMBER = 'Permit Number',
  PROPERTY_ADDRESS = 'Property Address',
  PROVIDER = 'Provider',
  TOTAL_REVENUE = 'Total Revenue',
  ALLOWABLE_DEDUCTIONS = 'Allowable Deductions',
  CHECKSUM = 'Checksum',
  ROW_ID = 'Row ID',
}

export interface TemplateRecord {
  [COLUMN_NAMES.PERIOD]: string;
  [COLUMN_NAMES.PERMIT_NUMBER]: string;
  [COLUMN_NAMES.PROPERTY_ADDRESS]: string;
  [COLUMN_NAMES.PROVIDER]: string;
  [COLUMN_NAMES.TOTAL_REVENUE]?: string;
  [COLUMN_NAMES.ALLOWABLE_DEDUCTIONS]?: string;
  [COLUMN_NAMES.ROW_ID]: string;
  [COLUMN_NAMES.CHECKSUM]?: string;
}

export interface TemplateErrors {
  [COLUMN_NAMES.PERIOD]?: string;
  [COLUMN_NAMES.PERMIT_NUMBER]?: string;
  [COLUMN_NAMES.PROPERTY_ADDRESS]?: string;
  [COLUMN_NAMES.PROVIDER]?: string;
  [COLUMN_NAMES.TOTAL_REVENUE]?: string;
  [COLUMN_NAMES.ALLOWABLE_DEDUCTIONS]?: string;
}

const CHECKSUM_COLUMNS = [
  COLUMN_NAMES.PERIOD,
  COLUMN_NAMES.PERMIT_NUMBER,
  COLUMN_NAMES.PROPERTY_ADDRESS,
  COLUMN_NAMES.PROVIDER,
];

export async function calculateChecksum(
  record: TemplateRecord
): Promise<string> {
  const values = CHECKSUM_COLUMNS.map((c) => String(record[c] ?? '').trim());

  const valueToHash = values.join(':');

  try {
    return await calculateSHA1Checksum(valueToHash);
  } catch (e) {
    return btoa(valueToHash);
  }
}

async function calculateSHA1Checksum(value: string): Promise<string> {
  const hashArrayBuffer = await crypto.subtle.digest(
    'SHA-1',
    new TextEncoder().encode(value)
  );
  return btoa(String.fromCharCode(...new Uint8Array(hashArrayBuffer)));
}
